import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Redirect, Route, Switch } from "react-router-dom";
import { NoticesPage } from "./notices/NoticesPage";
import { NoticeCreateModal } from "./notices/notice-create-modal/NoticeCreateModal";
import { NoticeSingle } from "./notices/notice-single/NoticeSingle";
import { NoticeEdit } from "./notices/notice-edit/NoticeEdit";

export default function OperationPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {
                    <Redirect
                        to={"/operation/notices"}
                        from={"/operation"}
                        exact={true}
                    />
                }

            <Route exact={true} path={"/operation/notices/new"}>
                {({ history, match }) => (
                    <NoticeCreateModal
                        show={match != null}
                        onHide={() => {
                            history.push("/operation/notices");
                        }}
                    />
                )}
            </Route>

            <ContentRoute
                path={"/operation/notices/:id/view"}
                component={NoticeSingle}
            />
            <ContentRoute
                path={"/operation/notices/:id/edit"}
                component={NoticeEdit}
            />
            <ContentRoute path={"/operation/notices"} component={NoticesPage} />
            </Switch>
                
        </Suspense>
    );
}
